export default "__VITE_ASSET__DhTP$Ax4__"